import auth from '../../middlewares/auth';
export const landingPagesRoute = [
  {
    path: '/landing-page-list',
    component: () =>
      import(
        /* webpackChunkName: "packages" */ '../../views/manage_landing_pages/LandingPageList.vue'
      ),
    name: 'landing_page_list',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/landing-page-add',
    component: () =>
      import(
        /* webpackChunkName: "packages" */ '../../views/manage_landing_pages/LandingPageForm.vue'
      ),
    name: 'landing_page_add',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/landing-page-edit/:id',
    component: () =>
      import(
        /* webpackChunkName: "packages" */ '../../views/manage_landing_pages/LandingPageForm.vue'
      ),
    name: 'landing_page_edit',
    meta: {
      middleware: [auth],
    },
  },
];
